import { C } from "./constants";
import { APP_FONT_SIZE } from "./theme";

/** Grid wrapper for birth-detail / form rows (responsive, no picker overlap). */
export const FORM_FIELD_GRID_CLASS = "ecliptica-form-grid";

/** Grid cell — allows shrinking below native date/time input intrinsic width. */
export const FORM_FIELD_CELL_CLASS = "ecliptica-form-field";

/** Single-column stack (mobile); omit on desktop for horizontal row layout. */
export const FORM_FIELD_GRID_STACKED_CLASS = "ecliptica-form-grid--stacked";

/** Four-column horizontal layout (wedding). */
export const FORM_FIELD_GRID_WIDE_CLASS = "ecliptica-form-grid--wide";

/** Apply to input[type=date|time] so width follows the grid column. */
export const NATIVE_PICKER_INPUT_CLASS = "ecliptica-native-picker";

export const NATIVE_PICKER_WRAP_CLASS = "ecliptica-native-picker-wrap";

export function formFieldGridClassName({ wide = false, stacked = false } = {}) {
  return [
    FORM_FIELD_GRID_CLASS,
    wide && FORM_FIELD_GRID_WIDE_CLASS,
    stacked && FORM_FIELD_GRID_STACKED_CLASS,
  ]
    .filter(Boolean)
    .join(" ");
}

/** Inline grid + className — inline wins if CSS bundle is stale; classes match formGrid.css. */
export function formFieldGridStyle({ wide = false, stacked = false } = {}) {
  if (stacked) {
    return {
      width: "100%",
      display: "grid",
      gridTemplateColumns: "1fr",
      rowGap: 16,
      columnGap: 0,
    };
  }

  return {
    width: "100%",
    display: "grid",
    gridTemplateColumns: wide
      ? "repeat(4, minmax(0, 1fr))"
      : "repeat(3, minmax(0, 1fr))",
    columnGap: 24,
    rowGap: 0,
  };
}

export function formFieldCellStyle() {
  return {
    minWidth: 0,
    maxWidth: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 0,
  };
}

export function buildFormInputStyle({ fontSize = APP_FONT_SIZE, extra = {} } = {}) {
  return {
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    boxSizing: "border-box",
    display: "block",
    background: "rgba(255,255,255,0.06)",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: 10,
    color: C.textPrimary,
    padding: "11px 14px",
    fontSize: fontSize - 1,
    fontFamily: "'DM Sans',sans-serif",
    outline: "none",
    ...extra,
  };
}

export function nativePickerInputProps(style) {
  return {
    className: NATIVE_PICKER_INPUT_CLASS,
    style,
  };
}
